module.exports = __webpack_public_path__ + "static/media/drawing.bafef538.ogg";